import { RelatedProduct } from '../../../types/api/entities/recipe';

export interface GetRecipeProductsAction {
  type: 'API/GET_RECIPE_PRODUCTS';
  payload: {
    recipeId: number;
    products: RelatedProduct[];
  };
}

export function getRecipeProducts(
  recipeId: number,
  products: RelatedProduct[],
): GetRecipeProductsAction {
  return {
    type: 'API/GET_RECIPE_PRODUCTS',
    payload: {
      recipeId,
      products,
    },
  };
}
